/**
 * DownloadMenu — Excel / CSV / PDF dropdown (CR-0015).
 *
 * CR-0024 (Δ-22, 2026-06-01): reverted the `typeFilter` prop added by
 * CR-0021's optional toggle clause. Backend defaults to `"waiting"`;
 * the UI no longer offers a way to download anything else.
 */
import { Download } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { exportUrl } from "@/api/reports";

export default function DownloadMenu({ tab, from, to }) {
  const open = (fmt) => {
    const url = exportUrl(tab, from, to, fmt);
    window.open(url, "_blank");
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="download-trigger"
          className="flex items-center gap-1 text-sm font-medium"
          style={{ color: "#2563EB" }}
        >
          <Download size={16} />
          Download
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="download-menu">
        <DropdownMenuItem
          data-testid="download-xlsx"
          onClick={() => open("xlsx")}
        >
          Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="download-csv"
          onClick={() => open("csv")}
        >
          CSV (.csv)
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="download-pdf"
          onClick={() => open("pdf")}
        >
          PDF (.pdf)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
